import { render, staticRenderFns } from "./UploadAdvertisingVideo.vue?vue&type=template&id=4baf161a&scoped=true"
import script from "./UploadAdvertisingVideo.vue?vue&type=script&lang=js"
export * from "./UploadAdvertisingVideo.vue?vue&type=script&lang=js"
import style0 from "./UploadAdvertisingVideo.vue?vue&type=style&index=0&id=4baf161a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4baf161a",
  null
  
)

export default component.exports